import lang from 'lodash/lang';
import { deepClone } from '../_util/clone';
/**
 * 把外面传进来的数据解除引用关联
 * @param dataSource
 * @returns {T[]}
 */

export function getDataSource(props) {
  return deepClone(props.data);
}
/**
 * 构建onChange参数
 * @param choosed
 * @param labelInValue
 * @param multiple
 * @returns {*}
 */

export function buildChangeValue(choosed, multiple) {
  if (multiple) {
    if (choosed.length) {
      return choosed;
    }

    return [];
  } else {
    if (choosed.length) {
      return choosed[0];
    }

    return undefined;
  }
}
export function isMultiple(props) {
  return props.multiple;
}
/**
 * 更新已选项
 * @param choosed
 * @param items
 */

export function updateChoosed(choosed, items) {
  choosed.length = 0;

  if (lang.isArray(items)) {
    items.forEach(function (item) {
      choosed.push(item);
    });
  } else {
    if (items === null || items === undefined) return;
    choosed.push(items);
  }
}
/**
 * 移除
 * @param choosed
 * @param item
 */

export function removeChoosed(choosed, item) {
  var index = choosed.indexOf(item);

  if (index >= 0) {
    choosed.splice(index, 1);
  }
}
export function getText(choosed) {
  return choosed ? choosed.name : '';
}
//# sourceMappingURL=util.js.map
